/**************************************************************************
 * Created on Tue Aug 27 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

import React, { useEffect, useState } from "react";
import axios, { AxiosError } from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { setCookie, ID_TOKEN_KEY } from "../../../interceptors/constant";
import DSSLoader from "../../../ui/building-blocks/atoms/dss-loader/dss-loader";
import { notifyError } from "../../../ui/dls/dls-snackbar/dls-snackbar";
import { SESSION_REQUEST_CONFIG, TOKEN_URL, loginurl } from "../../constant/constant";


const Login = () => {
    const { setAuth } = useAuth();

    const useQuery = () => new URLSearchParams(useLocation().search);

    const navigate = useNavigate();
    const [code] = useState(useQuery().get('code'));
    const storefront = "INDS";
    const from = '/userlogin';



    const startLoginProcess = () => {
        axios.get(`${TOKEN_URL}?code=${code}&storefrontName=${storefront}`, SESSION_REQUEST_CONFIG)
            .then(resp => {
                setCookie(ID_TOKEN_KEY, resp.data.user_id, resp.data.expires_in);
                setAuth({ isAuthenticated: resp.data.authenticated === true });

                navigate(from, { replace: true })
            }).catch((e: AxiosError) => {

                notifyError(e.message)

            })
    }




    useEffect(() => {

        localStorage.removeItem('currentuser');

        if (!code) {

            window.location.href = loginurl;
        }
        else {
            startLoginProcess();
        }


    }, [])
    return (<div style={{ width: "100vw", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <DSSLoader id="loader" />
    </div>);
};

export default Login;